export const Permissions = {
  hidden: 'hidden',
  admin: 'admin',
  view: 'view',
  user: 'user',
  upgrade: 'upgrade',
  editor: 'editor',
};

export const PermissionPageKey = {
  Dashboard: 'Dashboard',
  SCM: 'Supply Chain',
  Timeline: 'Timeline',
  PO: 'Purchase Orders',
  WO: 'Work Orders',
  Shipments: 'Shipments',
  SP: 'Storage Providers',
  Suppliers: 'Suppliers',
  Orders: 'Orders',
  CRM: 'CRM',
  Catalog: 'Catalog',
  Restock: 'Restock',
  Components: 'Components',
  DataStudio: 'Data Studio',
  FBAMonitoring: 'FBA Monitoring',
  InventoryReport: 'Inventory Report',
  LostRevenue: 'Lost Revenue',
  RevenueChart: 'Revenue Chart',
  TimeSeries: 'Time Series',
  Wholesale: 'Wholesale',
  Wholesalers: 'Wholesalers',
  Invoices: 'Invoices',
  GlobalPriceList: 'Global Price List',
  Settings: 'Settings',
  Attributes: 'Attributes',
  ClassificationGuide: 'Classification Guide',
  Analytics: 'Analytics',
  AwaitingActions: 'Awaiting Actions',
  Logs: 'Logs',
};

export const PermissionTabKey = {
  CatalogDiscontinued: 'Discontinued',
  CatalogMarketplaces: 'Marketplaces',
  CatalogQTYRules: 'QTY Rules',
  CatalogReturnPolicy: 'Return Policy',
  Carriers: 'Carriers',

  OrderCarrierServices: 'Carrier Services',
  OrderOrderMapping: 'Order Mapping',

  SettingsOrganization: 'Organization',
  SettingsUsers: 'Users',

  SPDetails: 'Details',
  SPShipments: 'Shipments',
  SPComponents: 'Components',
  SPShippingTemplate: 'Shipping Template',
  SPInventory: 'Inventory',
  SPLabel: 'label-rate',
  SPRateCard: 'Rate-card',
  SPInvoice: 'Invoices',
};
